import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {BillingService} from '../../service/billing/billingService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class BundleGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();		
		
		var bundleGrid = this;
		setTimeout(function(){
			bundleGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var bundleGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{	
					tag: 'vaadin-combo-box',
					itemid: 'status',						
					'class': 'spacer-toolbar-item',
					'item-value-path': 'code',
					'item-label-path': 'desc',
					'prevent-invalid-input': true,
					postinit: function(combo) {							
						combo.items = [
							{
								code: 'A',
								desc: 'Active'
							}, {
								code: 'I',
								desc: 'Inactive'
							}
						];
						combo.value = 'A';
					},
					listeners: {
						'selected-item-changed': function(event) {
							if (actionRefresh){
								actionRefresh();
							}
						}
					}
										
				},				
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_BILLING_PROMOTIONS:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')
					],
					listeners: {
						click: function() {							
							actionAddEdit();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_BILLING_PROMOTIONS:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')
					],
					listeners: {
						click: function() {							
							actionAddEdit(grid.selectedItems[0]);
						}
					}
				},							
				{
					tag: 'dl-action-button',
					itemid: 'delete',
					theme: 'error primary',					
					permissions: ['ADMIN_BILLING_PROMOTIONS:DELETE'],
					'class': 'spacer-toolbar-item',
					style: 'float: right;',					
					children:[
						ElementUtil.makeIcon('vaadin:trash', ' Delete')
					],
					listeners: {
						click: function() {
							actionCancel(grid.selectedItems[0]);
						}
					}
				}			
			]
		});	
		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}				
			},			
			children: [	
				{						
					path: 'bundleCode',
					header: 'Code',					
					width: '7em'
				},
				{						
					path: 'description',
					header: 'Description',					
					'flex-grow': '1'
				},				
				{						
					path: 'productCode',
					header: 'Product Code',
					width: '9em'
				},				
				{						
					path: 'sortSequence',
					header: 'Sort Sequence',					
					width: '7em',
					'text-align': 'center'
				},
				{						
					path: 'updateUser',
					header: 'Update User',					
					width: '9em'
				},
				{						
					path: 'updateDts',
					header: 'Update Date',						
					width: '9em',
					renderer: function(root, column, rowData) {
						if (rowData.item.updateDts) {
							var date = TimeUtil.parseDate(rowData.item.updateDts);						
							root.innerHTML = TimeUtil.formatDateStandard(date);						
						}
					}
				}				
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {						
						ElementUtil.query(toolbar, 'edit').disabled = false; 
						ElementUtil.query(toolbar, 'delete').disabled = false;
					} else {						
						ElementUtil.query(toolbar, 'edit').disabled = true;
						ElementUtil.query(toolbar, 'delete').disabled = true;
					}	
				}
			}
		});		
		
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 200,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
					
					bundleGrid.currentFilter = {
						offset: pageRange.offset,
						max: pageRange.max,
						sortField: backingGrid.currentSortField,
						sortOrder: backingGrid.currentSortDirection,
						status: ElementUtil.query(toolbar, 'status').value	
					};
					
					var successHandler = function(records) {
						loadMask.remove();
						grid.activeItem = null;						
						grid.items = records.data;
						
						bundleGrid.fullDataSet = records.data;						
						pagingToolbar.totalRecords = records.totalNumber;
						pagingToolbar.updatePager();						
					};
					
					BillingService.getBundlePromotionService().getBundles(bundleGrid.currentFilter)
					.then(function(records){							
						successHandler(records);
					});
										
				};
			},
			listeners: {
				ready: function() {					
					pagingToolbar.loadCurrentPage();
				}
			}
			
		});		
		
		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'bundles',
			onDetail: function() {
				ExportUtil.exportGridItemsAsCsv(grid.items, 'bundles.csv');
			}
		});

		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footer.footerContainer
			]
		});		
		bundleGrid.append(flexLayout);		
		
		
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);			
		};
		
		var actionAddEdit = function(record) {
			
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Add/Edit Bundle',
				icon: 'lumo:edit',
				listeners: {
					ready: function() {						
						addEditWin.show();
								
						var products = [];
						var productGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',
							slot: 'primary',
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true				
							},			
							children: [	
								{						
									path: 'productCode',
									header: 'Product',					
									width: '9em',
									renderer: function(root, column, rowData) {
										root.innerHTML = rowData.item.productCode + '-' + rowData.item.productFeatureCode;
									}
								},	
								{						
									path: 'description',
									header: 'Description',					
									'flex-grow': '1'
								},	
								{						
									path: 'promoDiscountAmt',
									header: 'Bundle Price',					
									width: '7em',
									renderer: function(root, column, rowData) {
										root.innerHTML = StringUtil.currencyFormat(rowData.item.bundlePrice);
									}
									
								}
							],
							listeners: {
								'active-item-changed': function(event) {
									const item = event.detail.value;
									productGrid.selectedItems = item ? [item] : [];
									if (productGrid.selectedItems.length > 0) {																
										ElementUtil.query(formPanel, 'remove').disabled = false;
									} else {																
										ElementUtil.query(formPanel, 'remove').disabled = true;
									}	
								}
							}
						});			
								
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [										
										{
											tag: 'vaadin-text-field',
											label: 'Bundle Code',
											name: 'bundleCode',
											required: true,
											maxlength: 20
										},	
										{
											tag: 'vaadin-text-field',
											label: 'Description',
											name: 'description',											
											required: true,
											maxlength: 255
										},
										{
											tag: 'vaadin-combo-box',											
											label: 'Product', 
											name: 'productCode',
											required: true,
											'item-value-path': 'code',
											'item-label-path': 'description',
											postinit: function(combo) {
												BillingService.getProductService().getProducts().then(function(dataResponse){
													var lookups = [];
													dataResponse.data.forEach(function(product){
														lookups.push({
															code: product.productCode,
															description: product.productName
														});
													});
													lookups.sort(function(a, b){
														return a.description.localeCompare(b.description);
													});
																										
													combo.items = lookups;
												});
											}
										},
										{
											tag: 'vaadin-number-field',
											label: 'Sort Sequence',
											name: 'sortSequence',											
											required: true,
											min: -9999,
											max: 9999
										},
										{
											tag: 'dl-section-title',
											title: 'Products',
											colspan: 2
										},							
										{
											tag: 'div',
											style: 'height: 200px',
											colspan: 2,
											children: [
												{
													tag: 'dl-flex-layout',
													children: [
														{
															tag: 'dl-toolbar',
															slot: 'toolbar',
															theme: 'spacing',
															children: [																				
																{
																	tag: 'vaadin-button',
																	itemid: 'add',
																	theme: 'primary',
																	'class': 'spacer-toolbar-item',
																	children:[
																		ElementUtil.makeIcon('vaadin:plus', ' Add')
																	],
																	listeners: {
																		click: function() {							
																			actionAddProduct();
																		}
																	}					
																},																						
																{
																	tag: 'vaadin-button',
																	itemid: 'remove',
																	theme: 'error primary',																						
																	'class': 'spacer-toolbar-item',
																	style: 'float: right;',					
																	children:[
																		ElementUtil.makeIcon('vaadin:close', ' Remove')
																	],
																	listeners: {
																		click: function() {
																			actionRemoveProduct(productGrid.selectedItems[0]);
																		}
																	}
																}			
															]
														},
														productGrid													
													]
												}
											]										
										},										
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
																
															formPanel.submitForm({
																preSubmit: function(data) {
																
																	var bundleModel = {
																		bundle: data,
																		products: []
																	};
																	
																	//construct products
																	products.forEach(function(item){																		
																		bundleModel.products.push({
																			bundleCode: data.bundleCode,
																			productCode: item.productCode,
																			productFeatureCode: item.productFeatureCode,
																			bundlePrice: item.bundlePrice																			
																		});
																	});
																
																	return bundleModel;
																},
																actualCall: function(data) {
																	return BillingService.getBundlePromotionService().saveBundle(data, record ? true : false);
																},
																success: function(data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved Bundle', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	if (formPanel.successCallback) {
																		formPanel.successCallback();
																	}
																	actionRefresh();
																	addEditWin.close();
																}
															});
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]

						});
						addEditWin.addToContentElement(formPanel);	
						
						if (record) {
							
							//load detailed record
							var loadMask = formPanel.showLoading();
							BillingService.getBundlePromotionService().getBundleDetail(record.bundleCode).then(function(detail){
								loadMask.remove();
								
								formPanel.load(record, {
									refreshComponents: true
								});
								
								products = detail.bundleProducts;								
								actionRefreshItems();	
								
							});
						}
						
						var actionRefreshItems = function() {
							productGrid.activeItem = null;
							productGrid.items = products.slice(0);				
						};
						
						var actionAddProduct = function() {
						
							var addItemWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: 'Add Product',
								icon: 'lumo:edit',
								width: '75%',
								height: 250,
								listeners: {
									ready: function() {						
										addItemWin.show();
																				
										var itemFormPanel = ElementUtil.create({
											tag: 'dl-form-panel',
											itemid: 'form',
											children: [
												{
													tag: 'vaadin-form-layout',										
													children: [																								
														{
															tag: 'vaadin-combo-box',											
															itemid: 'productItem',
															label: 'Product', 
															name: 'productCode',
															'item-value-path': 'code',
															'item-label-path': 'itemDesc',
															postinit: function(combo) {
																
																BillingService.getProductService().getEffectiveProductItems().then(function(data){
																	//format the code
																	var productItems = [];
																	data.forEach(function(item){																		
																		var productItem = item.productItem;
																		productItem.code = productItem.productItemPK.productCode + "-" + productItem.productItemPK.featureProductCode;
																		productItems.push(productItem);
																	});
																	productItems.sort(function(a, b){
																		return a.itemDesc.localeCompare(b.itemDesc);
																	});
																	
																	combo.items = productItems;
																	combo.required = true;
																});
															}
														},										
														{
															tag: 'vaadin-number-field',
															label: 'Bundle Price',
															name: 'bundlePrice',
															required: true,															
															min: 0,
															max: 999999
														},							
														{
															tag: 'hr',
															colspan: 2
														},
														{
															tag: 'div',
															style: 'text-align: center;',
															colspan: 2,
															defaults: {
																tag: 'vaadin-button'
															},
															children: [
																{
																	theme: 'primary',
																	children: [
																		ElementUtil.makeIcon('vaadin:database', ' Save')
																	],
																	listeners: {
																		click: function() {		
																			var data = itemFormPanel.getData();
																			var productItemCB = ElementUtil.query(itemFormPanel, 'productItem');
																			var productItemValue = productItemCB.selectedItem;																			
																			var productData = {
																				description: productItemValue.itemDesc,
																				productCode: productItemValue.productItemPK.productCode,
																				productFeatureCode: productItemValue.productItemPK.featureProductCode,
																				bundlePrice: data.bundlePrice
																			};																			
																			
																			products.push(productData);
																			actionRefreshItems();
																			addItemWin.close();
																		}
																	}
																},
																{
																	theme: 'tertiary',
																	innerHTML: 'Cancel',
																	style: 'margin-left: 10px;',
																	listeners: {
																		click: function() {
																			//cancel
																			addItemWin.close();
																		}
																	}
																}
															]
														}
													]
												}
											]

										});
										addItemWin.addToContentElement(itemFormPanel);	
										
									}
								}
							});
							
						};
						
						var actionRemoveProduct = function(productItem) {
							var newItems = [];
							products.forEach(function(item){
								if (!(item.productCode === productItem.productCode  
									&& item.featureProductCode === productItem.featureProductCode)) {
									newItems.push(item);
								}
							});	
							products = newItems;
							actionRefreshItems();
						};
					}
				}
			});
		
						
		};
		
		var actionCancel = function(record) {
			var summary = window.DL.MessageUtil.ellipseText(record.bundleCode, 20);
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to cancel ' + summary + ' bundle?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Deleting...');													
							
							BillingService.getBundlePromotionService().deleteBundle(record.bundleCode).then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Deleted: ' + summary, {									
									theme: 'success'
								});
								actionRefresh();
							});															
							
						}	
					},
					{
						text: 'No'
					}
				]
			});				
		};		

	}
	
};
customElements.define('dl-bundle-grid', BundleGrid);
